import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {
  auditLog = 'api/Audit';
  constructor(private _auditLogHttp: RestApi) { }

  getFilters(): Observable<any> {
    return this._auditLogHttp.get(`${this.auditLog}/GetFilters`);
  }

  getUsers(): Observable<any> {
    return this._auditLogHttp.get(`${this.auditLog}/GetUsers`);
  }

  getAuditLog(auditLog: IAuditLogFilter): Observable<any> {
    return this._auditLogHttp.post(`${this.auditLog}/Detail`, auditLog);
  }
}
